import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
  Avatar,
  Box,
  Tab,
  Tabs,
  IconButton,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import { connect } from "react-redux";
import { START_STATUS_PATIENT_UPDATE } from "../../Actions/PatientAction";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipOrderdate";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import AutoCompleteTextField from "../../Components/Common/AutoCompleteTextField";
import moment from "moment";
import { capitalizeFirstLetter } from "../../utils/generalUtils";
import { useSelector, useDispatch } from "react-redux";
import { START_COLLECT_MARK_AS_URGENT } from "../../Actions/CollectionAction";
import PageLoading from "../../Components/Common/PageLoading";
import Button from "../../Components/Common/Button/Button";
import "../../Sass/Common.scss";
import clsx from "clsx";
import { ReactComponent as CloseIcon } from "Assets/Icons/CloseIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import Chips from "../../Components/Common/Chips";
import { statusMenuItems, InstallmentDispensingDetail } from "../../utils/data";
import PatientCreateDialog from "./PatientCreateDialog";
import { ReactComponent as PatientDetails } from "../../Assets/Icons/PharmsmartIcon/PatientDetails.svg";
import { ReactComponent as PhoneIcon } from "../../Assets/Icons/PharmsmartIcon/PhoneIcon.svg";
import { ReactComponent as LocationIcon } from "../../Assets/Icons/PharmsmartIcon/Location.svg";
import { ReactComponent as CrossIconCircle } from "../../Assets/Icons/PharmsmartIcon/CrossIconCircle.svg";
import { ReactComponent as TickIconCircle } from "../../Assets/Icons/PharmsmartIcon/TickIconCircle.svg";
import { ReactComponent as Editicons } from "../../Assets/Icons/PharmsmartIcon/EditIcons.svg";

import useViewport from "../../Hooks/useViewport";
const FaxDialog = React.lazy(() =>
  import("../../Components/Common/Dialog/FaxDialog")
);
const ViewOrderDialog = React.lazy(() =>
  import("../../Components/Common/Dialog/ViewOrderDialog")
);

const useStyle = makeStyles((theme) => ({
  rsViewRxMain: {
    marginTop: "30px !important",
    maxWidth: "380px",
    [theme.breakpoints.down("690")]: {
      display: "grid",
      gridTemplateColumns: "auto auto",
      minWidth: "100%",
      gridGap: "5px",
    },
    [theme.breakpoints.down("485")]: {
      display: "grid",
      gridTemplateColumns: "auto",
      minWidth: "100%",
    },
    "&>svg": {
      width: "80px",
      height: "100px",
    },
    "&>h4": {
      fontSize: "15px !important",
      whiteSpace: "nowrap",
      color: "black",
    },
    "&>h5": {
      fontSize: "15px !important",
      display: "flex",
      whiteSpace: "nowrap",
    },
    "&>div": {
      display: "flex",
      marginBottom: "10px",
      // marginLeft: "-20px",
      // whiteSpace: "nowrap",
      // justifyContent: "center",
      // justifyItems: "center",
      alignItems: "flex-start",
      "&>h4": {
        fontSize: "1.025rem !important",
        fontWeight: "600 !important",
        // whiteSpace: "nowrap",
        color: "#262626",
        marginLeft: "5px",
      },
      "&>h5": {
        fontSize: "1.025rem !important",
        display: "flex",
        //fontWeight: "400 !important",
        // whiteSpace: "nowrap",
        color: "#262626",
        marginLeft: "5px",
      },
    },
  },
  // innerdetials: {
  //   marginLeft: "0px !important",
  // },
  // innerdata: {
  //   marginLeft: "12px !important",
  // },

  resStatus: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("568")]: {
      flexDirection: "column !important",
      alignItems: "flex-start",
    },
  },
  innerStyle: {
    display: "flex",
    marginBottom: "10px",
    whiteSpace: "nowrap",
    // justifyContent: "center",
    // justifyItems: "center",
    alignItems: "center",
    "&>h4": {
      fontSize: "18px !important",
      fontWeight: "500 !important",
      whiteSpace: "nowrap",
      color: "#262626",
      marginLeft: "5px",
    },
    "&>h5": {
      fontSize: "18px !important",
      display: "flex",
      fontWeight: "400 !important",
      whiteSpace: "nowrap",
      color: "#262626",
      marginLeft: "5px",
    },
  },
  repeatOrder: {
    "&>h4": {
      fontSize: "18px !important",
      fontWeight: "600 !important",
      whiteSpace: "nowrap",
      color: "#7BC044 !important",
      marginLeft: "5px",
    },
    "&>h5": {
      fontSize: "18px !important",
      display: "flex",
      fontWeight: "600 !important",
      whiteSpace: "nowrap",
      color: "#0F0F0F !important",
      marginLeft: "5px",
    },
    [theme.breakpoints.down("690")]: {
      display: "flex",
      flexDirection: "row",
      "&>h4": {
        fontSize: "1.025rem !important",
        fontWeight: "600 !important",
        // whiteSpace: "nowrap",
        color: "#262626",
        marginLeft: "5px",
      },
      "&>h5": {
        fontSize: "1.025rem !important",
        display: "flex",
        fontWeight: "400 !important",
        // whiteSpace: "nowrap",
        color: "#262626",
        marginLeft: "5px",
      },
    },
  },
  // innercontainer: {
  //   width: "450px",
  //   [theme.breakpoints.down("892")]: {
  //     Width: "700px",
  //   },
  //   [theme.breakpoints.down("868")]: {
  //     maxWidth: "450px",
  //   },
  //   [theme.breakpoints.down("817")]: {
  //     maxWidth: "450px",
  //   },
  //   [theme.breakpoints.down("690")]: {
  //     height: "unset",
  //     maxWidth: "400px",
  //   },
  //   [theme.breakpoints.down("500")]: {
  //     minWidth: "unset",
  //     maxWidth: "400px",
  //   },
  //},
  rsViewColum: {
    marginTop: "20px",
    //border: "1px solid #7BC044",
    border: "1px solid rgba(238, 202, 60, 1)",
    borderRadius: "5px",
    // background: "rgba(123, 192, 68, 0.05)",
    background: "rgba(238, 202, 60, 0.42)",
    height: "auto",
    // minHeight: "177px",
    maxHeight: "190px",
    minWidth: "425px",
    overflow: "auto",
    // [theme.breakpoints.down("892")]: {
    //   maxWidth: "300px",
    // },
    // [theme.breakpoints.down("868")]: {
    //   maxWidth: "351px",
    // },
    // [theme.breakpoints.down("817")]: {
    //   maxWidth: "300px",
    // },
    [theme.breakpoints.down("690")]: {
      height: "unset",
    },
    [theme.breakpoints.down("500")]: {
      minWidth: "unset",
    },
    "&>svg": {
      width: "80px",
      height: "100px",
    },
    "&>h4": {
      fontSize: "16px !important",
      whiteSpace: "nowrap",
      fontWeight: "500 !important",
      color: "#7BC044",
      // color: "rgba(238, 202, 60, 1)",
    },
    "&>h5": {
      fontSize: "15px !important",
      display: "flex",
      whiteSpace: "nowrap",
    },
    "&> div": {
      display: "block",
      marginBottom: "10px",
      // paddingTop: "20px",
      // paddingBottom: "20px",
      // paddingLeft: "30px" ,
      // paddingRight: "20px",
      "&>h4": {
        fontSize: "16px !important",
        whiteSpace: "nowrap",
        fontWeight: "500 !important",
        //color: "#7BC044",
        color: "black",
        width: "fit-content",
        marginLeft: "12px",
        marginTop: "12px",
        marginBottom: "5px",
      },
    },
  },
  rsViewColumTag: {
    marginTop: "20px",
    "&>svg": {
      width: "80px",
      height: "100px",
    },
    "&>h4": {
      fontSize: "15px !important",
      whiteSpace: "nowrap",
    },
    "&>h5": {
      fontSize: "15px !important",
      display: "flex",
      whiteSpace: "nowrap",
    },
    "&> div": {
      display: "flex",
      marginBottom: "10px",
      "&>h4": {
        fontSize: "15px !important",
        whiteSpace: "nowrap",
        color: "black",
      },
    },
  },
  rsInputDivider: {
    width: "1px",
    height: "180px",
    background: `${theme.palette.secondary.main}50 !important`,
    margin: "27px 26px 0px 20px !important",
  },
  tableContainer: {
    marginBottom: "6px !important",
    height: "auto !important",
    // minHeight: "100px",
    maxHeight: "279px !important",
    overflowY: "auto",
    padding: "0 !important",
    boxShadow: "0px 0px 0px rgba(26, 102, 122, 0.1) !important",
    borderTop: "1px solid #e0e0e0 !important",
    borderBottom: "1px solid #e0e0e0 !important",
    "@media (max-height: 912px)": {
      maxHeight: "250px !important",
    },
    "@media (max-height: 840px)": {
      maxHeight: "220px !important",
    },
    "@media (max-height: 805px)": {
      maxHeight: "200px !important",
    },
    "@media (max-height: 785px)": {
      maxHeight: "160px !important",
    },
    [theme.breakpoints.down("769")]: {
      maxHeight: "unset !important",
    },
    "&>table": {
      borderRight: "1px solid #e0e0e0 !important",
      "&>thead": {
        "&>tr": {
          "&>th": {
            paddingBottom: "10px !important",
            paddingTop: "10px !important",
            fontWeight: "600 !important",
            fontFamily: "Poppins !important",
            fontSize: "18px !important",
            "&:first-child": {
              borderRight: "none !important",
              minWidth: "150px",
            },
            "&:last-child": {
              minWidth: "173px",
            },
          },
        },
      },
    },
  },
  rsOrderDetailText: {
    fontSize: "19px !important",
    whiteSpace: "nowrap !important",
  },
  rsFromLabel: {
    marginRight: "10px !important",
    "& .MuiFormControlLabel-label": {
      fontWeight: "600",
    },
    [theme.breakpoints.down("983")]: {
      width: "580px !important",
    },
  },
  avatarStyle: {
    width: "80px !important",
    height: "80px !important",
    fontSize: "xx-large !important",
    marginBottom: "10px",
  },
  noteStyle: {
    width: "380px",
    justifyContent: "center",
  },
  tableBody: {
    "&>td": {
      padding: "5px 10px !important",
      [theme.breakpoints.down("768")]: {
        wordBreak: "auto-phrase",
      },
      "&:first-child": {
        borderRight: "none !important",
      },
    },
  },
  tableName: {
    fontSize: "16px !important",
    fontWeight: "400 !important",
    color: "#262626 !important",
  },
  tableAlign: {
    padding: "10px !important",
    border: "none !important",
    width: "250px",
  },
  textJustify: {
    padding: "10px !important",
    border: "none !important",
    paddingLeft: "20px !important",
  },
  rxNameDisplayCls: {
    marginTop: "10px",
    "&>div": {
      display: "flex",
    },
  },
  rsChipScheduled: {
    backgroundColor: "rgb(220 241 204) !important",
    border: `0.5px solid ${theme.palette.primary.main}`,
    color: ` ${theme.palette.primary.main} !important`,
    borderRadius: "5px !important",
    width: "50px !important",
    borderColor: ` ${theme.palette.primary.main} !important`,
  },
  rsCollectedStatusOne: {
    backgroundColor: "rgb(220 241 204) !important",
    border: `0.5px solid ${theme.palette.primary.main} !important`,
    color: ` ${theme.palette.primary.main} !important`,
    borderRadius: "5px",
    width: "100%",
  },
  rsCollectedStatusTwo: {
    backgroundColor: "rgba(233, 81, 78, 0.2) !important",
    border: "0.5px solid #E9514E !important",
    color: "#E9514E !important",
    borderRadius: "5px",
    width: "100%",
  },
  rsArchived: {
    backgroundColor: "#7BC044 !important",
    borderRadius: "5px",
    width: "fit-content",
    paddingLeft: "10px",
    paddingRight: "10px",
    color: "white",
    fontWeight: "500",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  rsDialogMainRoot: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      position: "absolute",
      // top: "60px !important",
      // maxHeight:"calc(100% - 164px)",
      top: "25px !important",
      maxHeight: "calc(100% - 86px)",
      paddingTop: "20px",
      "@media (max-height: 880px)": {
        top: "0px !important",
        maxHeight: "calc(100% - 30px)",
      },
      "@media (max-height: 840px)": {
        top: "-16px !important",
        maxHeight: "calc(100% - 36px)",
      },
      "@media (max-height: 800px)": {
        top: "-16px !important",
        maxHeight: "calc(100% - 36px)",
      },
      // [theme.breakpoints.down("925")]: {
      //   maxWidth: "95% !important",
      // },
    },
  },
  rsMobView: {
    whiteSpace: "nowrap",
  },
  rsNote: {
    marginLeft: "30px",
    "&>li": {
      listStyleType: "disc",
      "&>h5": {
        color: "#262626",
        fontSize: "14px !important",
        [theme.breakpoints.down("540")]: {
          whiteSpace: "normal",
          wordWrap: "breakWord",
          width: "fit-content",
        },
      },
    },
  },
  rsCollectionTab: {
    paddingTop: "10px",
    paddingBottom: "10px",
    marginTop: "11px",
    display: "flex",
    justifyContent: "space-between",
    "@media (max-height: 750px)": {
      paddingTop: "0px",
      marginTop: "0px",
    },
    "&>button": {
      height: "37px !important",
    },
    "&>div": {
      width: "fit-content",
      [theme.breakpoints.down("426")]: {
        "&>button": {
          marginTop: "10px",
        },
      },
    },
    [theme.breakpoints.down("426")]: {
      flexDirection: "column !important",
      "&>button": {
        marginTop: "10px",
      },
    },
  },
  rsCollectionTabBtn: {
    whiteSpace: "nowrap !important",
    borderRadius: "5px !important",
    marginRight: "10px !important",
    fontSize: "14px  !important",
    height: "37px !important",
    backgroundColor: `${theme.palette.white.main} !important`,
    borderColor: `${theme.palette.primary.main} !important`,
    [theme.breakpoints.down("500")]: {
      fontSize: "12px  !important",
    },
    [theme.breakpoints.down("400")]: {
      fontSize: "11px  !important",
    },
    color: `${theme.palette.primary.main} !important`,

    "&>h6": {
      background: "rgba(90, 104, 114, 0.1)",
      border: `0.5px solid ${theme.palette.secondary.main}`,
      height: "20px",
      width: "35px",
      borderRadius: "2px",
      paddingRight: "-5px",
      color: `${theme.palette.secondary.main} !important`,
      [theme.breakpoints.down("768")]: {
        width: "33px",
      },
      [theme.breakpoints.down("400")]: {
        width: "32px !important",
      },
    },
  },
  rsActiveButton: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.white.main} !important`,
    height: "37px !important",
    "&>h6": {
      background: "rgba(255, 255, 255, 0.1)",
      border: "0.5px solid #FFFFFF",
      height: "20px",
      width: "35px",
      borderRadius: "2px",
      paddingRight: "-5px",
      color: `${theme.palette.white.main} !important`,
    },
  },
  rsTableRow: {
    "&>td": {
      padding: "10px 17px !important",
    },
  },
  rsAvatar: {
    justifyContent: "center",
    display: "flex",
    alignItem: "center",
    marginTop: "15px !important",
  },
  rsDisableArchived: {
    backgroundColor: "rgba(0, 0, 0, 0.12) !important",
    borderRadius: "5px",
    width: "fit-content",
    paddingLeft: "10px",
    paddingRight: "10px",
    color: "#5A687290",
    fontWeight: "500",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  rsDialogTitle: {
    padding: "0px !important",
    justifyContent: "center !important",
    "&>button": {
      // position: "absolute",
      // display: "flex",
      // // top: "18px",
      // right: "20px",
    },
    "&>p": {
      color: "rgb(123, 192, 68) !important",
    },
    "&>div": {
      padding: "0px !important",
    },
  },
  rsTags: {
    display: "contents !important",
    [theme.breakpoints.down("700")]: {
      display: "inline !important",
    },
  },
  rsEditbutton: {
    marginRight: "5px",
  },
  headerTop: {
    display: "flex",
    marginTop: "-10px",
    marginLeft: "20px",
    marginRight: "27px",
    justifyContent: "space-between",
    [theme.breakpoints.down("690")]: {
      flexDirection: "column !important",
    },
  },
  patientStatusContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "20px",
    justifyContent: "end",
    [theme.breakpoints.down("690")]: {
      marginTop: "5px",
      // justifyContent: "space-between",
      width: "50%",
    },
    [theme.breakpoints.down("568")]: {
      width: "70%",
      marginLeft: "-11px",
    },
    [theme.breakpoints.down("450")]: {
      width: "100%",
    },
    "&>h4": {
      width: "30%",
      fontWeight: "600",
      color: "rgba(123, 192, 68, 1)",
      [theme.breakpoints.down("690")]: {
        width: "50%",
      },
    },
  },

  status: {
    width: "45%",
    // [theme.breakpoints.down("690")]: {
    //   width: "30%",
    // },
    "&>div": {
      "&>div": {
        marginTop: "0px",
        "&>div": {
          "&>input::placeholder": {
            color: "black !important",
          },
          "&>input": {
            color: "black !important",
          },
        },
      },
    },
  },
}));

const PatientDetailDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    collectedUncollectedListShow,
    collectionViewRxAction,
    collectionViewRxDetails,
    collectAndUncollectedViewRxDetails,
    getSinglePatientAction,
    data,
    patientId,
    getPatientHistoryAction,
    patientMedicationHistoryList,
    handleMediArchive,
    orderCountPayload,
    countUpdateFlag,
    getPatientStatusUpdatAction,
    statusUpdate,
    getList = () => {},
  } = props;
  const [openViewOrder, setOpenViewOrder] = useState(false);
  const [isOpenStatusList, setIsOpenStatusList] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [isUrgent, setIsUrgent] = useState(false);
  const { loginUserDetail } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const { collectMarkAsUrgentData } = useSelector((state) => state.collection);
  const [openFaxOrder, setOpenFaxOrder] = useState(false);
  const [tabValue, setTabValue] = useState("medication");
  const [phone, setPhone] = useState(false);
  const [viewOrderData, setViewOrderData] = useState({});
  const [openCreatePatientPopup, setOpenCreatePatientPopup] = useState(false);
  const [medicationTable, setMedicationTable] = useState("medication");
  let tempCollected = 0;
  let tempRemoved = 0;
  let { width } = useViewport();
  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const fullName = `${capitalizeFirstLetter(
    data?.data?.name
  )} ${capitalizeFirstLetter(data?.data?.last_name)}`;
  const dob = data?.data?.dob
    ? `(${moment(new Date(data?.data?.dob)).format("DD-MM-YYYY") || "N/A"})`
    : "";
  /** handle close */
  const handleClose = () => {
    setOpen(false);
    setIsUrgent(false);
    setMedicationTable("medication");
  };

  /** handle get data on open  */
  useEffect(() => {
    if (open && openCreatePatientPopup === false) {
      getSinglePatientAction(patientId);
      getPatientHistoryAction(patientId, {
        offset: 0,
        limit: 20,
      });
    }
  }, [open, openCreatePatientPopup]);

  /** get api data */
  useEffect(() => {
    if (collectionViewRxDetails?.data?.status == 1) {
      setIsUrgent(true);
    }
  }, [collectionViewRxDetails?.data?.status]);

  /** handle string avatar */
  function stringAvatar(data) {
    let firstName = `${capitalizeFirstLetter(
      data?.name
    )} ${capitalizeFirstLetter(data?.last_name)}`;
    return {
      children: `${firstName.split(" ")[0][0]}${firstName.split(" ")[1][0]}`,
    };
  }
  const handleChangetab = (e) => {};

  const handleStatusChange = (value) => {
    let params = {
      status: value.value,
    };
    setStatusValue(value.label);
    getPatientStatusUpdatAction(patientId, params);
  };

  // Set Patient Status Data
  useEffect(() => {
    if (open && data?.data && data?.data?.status) {
      setStatusValue(data?.data?.status);
    }
  }, [open, data?.data]);

  // API call on Status Change Success
  useEffect(() => {
    if (!statusUpdate?.loading && statusUpdate?.data?.success) {
      getList();
    }
  }, [statusUpdate?.data?.success]);

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={clsx("rsDialogMain", classes.rsDialogMainRoot)}
        // className={classes.rsDialogMainRoot}
      >
        <DialogTitle className={classes.rsDialogTitle}>
          <PrimaryDialogTitle
            title="Patient details"
            icon={PatientDetails}
            // NoteTextIcon
            handleClose={typeof handleClose == "function" ? handleClose : ""}
          />
          {/* <Typography> Patient details </Typography>{" "} */}
          {/* {typeof handleClose == "function" && (
            <IconButton onClick={() => handleClose()}>
              {" "}
              <PrimaryIcon icon={CloseIcon} />{" "}
            </IconButton>
          )} */}
        </DialogTitle>

        {/* {data?.loading ? (
          <PageLoading />
        ) : (
          <> */}
        <DialogContent className={clsx("RsDf_form")}>
          {data?.loading ? (
            <Grid
              display={"flex"}
              height="100px"
              justifyContent={"center"}
              // rowSpacing={1}
              // columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <CircularProgress />
            </Grid>
          ) : (
            <>
              <Grid
                display={"flex"}
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                className={classes.headerTop}
              >
                <Grid className={classes.rsViewRxMain}>
                  {/* <Grid item xs={6} className={classes.rsAvatar}>
                    <Avatar
                      className={classes.avatarStyle}
                      {...stringAvatar(data?.data)}
                    />
                    &nbsp;&nbsp;
                  </Grid> */}
                  <Grid item xs={6}>
                    <PatientDetails width={"20px"} height={"20px"} />
                    {/* <Typography medium variant="h4">
                      Name:&nbsp;
                    </Typography> */}
                    <Box display="flex" flexDirection="column">
                      <Box display="flex" flexWrap="wrap" alignItems="baseline">
                        <Typography
                          variant="h4"
                          component="span"
                          style={{
                            marginRight: dob ? 8 : 0,
                            fontSize: "1.025rem !important",
                            color: "#262626",
                            fontWeight: "600",
                            marginLeft: "5px",
                          }}
                        >
                          {fullName}
                        </Typography>
                        {dob && (
                          <Typography variant="h5" component="span">
                            {dob}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={6} className={classes.rsTags}>
                    {/* <Typography medium variant="h4">
                      Tags: &nbsp;
                    </Typography> */}
                    {/* {data?.data?.status && data?.data?.status !== "Active" && (
                      <Chips
                        // key={i}
                        label={data?.data?.status}
                        color={
                          data?.data?.status === "Absent"
                            ? "rgba(107, 107, 107,0.6)"
                            : data?.data?.status === "In-Hospital"
                            ? "rgba(210, 162, 68,0.6)"
                            : data?.data?.status === "Deceased"
                            ? "rgba(255, 0, 0,0.6)"
                            : "rgba(28, 176, 68,0.6)"
                        }
                        onClick={(e, index) => {
                          // handleStatusOpen(i);
                        }}
                      />
                    )} */}
                    {data?.data?.tags?.map((tagvalue) => {
                      return (
                        <Chips
                          className={classes.cursorMain}
                          rippleEffectEnabled={true}
                          click
                          label={tagvalue?.pit_name}
                          color={tagvalue?.pit_colour_code}
                        />
                      );
                    })}
                    {/* {data?.data?.instalment_type && (
                      <Chips
                        label={
                          InstallmentDispensingDetail[
                            data?.data?.instalment_type
                          ].label
                        }
                        color={"rgba(56, 91, 177, 0.6)"}
                      />
                    )}
                    {data?.data?.type === "collection" && (
                      <Chips label="Collection" color={"#429600"} />
                    )}
                    {data?.data?.type === "delivery" && (
                      <Chips
                        label="Delivery"
                        color={"rgba(218, 120, 32, 0.6) "}
                      />
                    )}
                    {data?.data?.compliance_aid && (
                      <Chips
                        label="Compliance"
                        color={"rgba(137, 156, 18, 0.6)"}
                      />
                    )} */}
                  </Grid>

                  <Grid item xs={6} className={classes.innerdetials}>
                    <Typography medium variant="h4">
                      Surgery:&nbsp;
                    </Typography>
                    <Typography regular variant="h5">
                      {capitalizeFirstLetter(data?.data?.surgery?.name || "-")}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.innerdetials}>
                    <Typography medium variant="h4">
                      Pharmacy:&nbsp;
                    </Typography>
                    <Typography regular variant="h5">
                      {capitalizeFirstLetter(data?.data?.pharmacy?.name || "-")}
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={6} className={classes.innerdata}>
                    <Typography medium variant="h4">
                      NHS NO:&nbsp;
                    </Typography>
                    <Typography regular variant="h5">
                      {capitalizeFirstLetter(data?.data?.nhs_number || "-")}
                    </Typography>
                  </Grid> */}
                  <Grid item xs={6} className={classes.innerdata}>
                    <Box>
                      <LocationIcon width={"20px"} height={"20px"} />
                    </Box>
                    <Typography medium variant="h4">
                      Address:&nbsp;
                    </Typography>
                    <Typography regular variant="h5">
                      {capitalizeFirstLetter(data?.data?.address || "-")}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.innerdata}>
                    <PhoneIcon width={"20px"} height={"20px"} />
                    <Typography medium variant="h4">
                      Phone no:&nbsp;
                    </Typography>
                    <Typography regular variant="h5">
                      {capitalizeFirstLetter(data?.data?.phone || "-")}
                    </Typography>
                  </Grid>
                  {width > 690 && (
                    <Grid item xs={6} className={classes.repeatOrder}>
                      <Typography medium variant="h4">
                        Total Repeat Orders:&nbsp;
                      </Typography>
                      <Typography regular variant="h5">
                        {data?.data?.order_count || "-"}
                      </Typography>
                    </Grid>
                  )}
                  {/* <Grid item xs={6}>
                    <Typography medium variant="h4">
                      Surgery:&nbsp;
                    </Typography>
                    <Typography regular variant="h5">
                      {capitalizeFirstLetter(data?.data?.surgery?.name || "-")}
                    </Typography>
                  </Grid> */}
                  {/* <Grid item xs={6}>
                    <Typography medium variant="h4">
                      Pharmacy: &nbsp;
                    </Typography>
                    <Typography regular variant="h5">
                      {" "}
                      {capitalizeFirstLetter(data?.data?.pharmacy?.name || "-")}
                    </Typography>
                  </Grid> */}
                </Grid>
                {width < 690 && (
                  <Grid className={classes.resStatus}>
                    <Grid item xs={6} className={classes.repeatOrder}>
                      <Typography medium variant="h4">
                        Total Repeat Orders:&nbsp;
                      </Typography>
                      <Typography regular variant="h5">
                        {data?.data?.order_count || "-"}
                      </Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.patientStatusContainer}
                    >
                      <Typography variant="h4">Patient Status</Typography>
                      <Grid
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.status}
                      >
                        <AutoCompleteTextField
                          open={isOpenStatusList}
                          onOpen={() => {
                            setIsOpenStatusList(true);
                          }}
                          onClose={() => {
                            setIsOpenStatusList(false);
                          }}
                          fullWidth
                          options={statusMenuItems}
                          inputValue={statusValue}
                          getOptionLabel={(option) => option.label}
                          filterOptions={(option) => {
                            let result = [...option];
                            return result || [];
                          }}
                          onChange={(e, value) => handleStatusChange(value)}
                          placeholder="Status"
                          // label="Status *"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {/* <Divider className={classes.rsInputDivider} /> */}
                {/* <Grid className={classes.rsViewColumTag}>
                  <Grid item xs={6}>
                    <Typography medium variant="h4">
                      Repeat orders: &nbsp;
                    </Typography>
                    <Typography regular variant="h5">
                      {" "}
                      {data?.data?.order_count || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.rsTags}>
                    <Typography medium variant="h4">
                      Tags: &nbsp;
                    </Typography>
                    {data?.data?.status && data?.data?.status !== "Active" && (
                      <Chips
                        // key={i}
                        label={data?.data?.status}
                        color={
                          data?.data?.status === "Absent"
                            ? "rgba(107, 107, 107,0.6)"
                            : data?.data?.status === "In-Hospital"
                            ? "rgba(210, 162, 68,0.6)"
                            : data?.data?.status === "Deceased"
                            ? "rgba(255, 0, 0,0.6)"
                            : "rgba(28, 176, 68,0.6)"
                        }
                        onClick={(e, index) => {
                          // handleStatusOpen(i);
                        }}
                      />
                    )}
                    {data?.data?.instalment_type && (
                      <Chips
                        label={
                          InstallmentDispensingDetail[
                            data?.data?.instalment_type
                          ].label
                        }
                        color={"rgba(56, 91, 177, 0.6)"}
                      />
                    )}
                    {data?.data?.type === "collection" && (
                      <Chips label="Collection" color={"#429600"} />
                    )}
                    {data?.data?.type === "delivery" && (
                      <Chips
                        label="Delivery"
                        color={"rgba(218, 120, 32, 0.6) "}
                      />
                    )}
                    {data?.data?.compliance_aid && (
                      <Chips
                        label="Compliance"
                        color={"rgba(137, 156, 18, 0.6)"}
                      />
                    )}
                  </Grid>
                </Grid> */}
                {/* <Divider className={classes.rsInputDivider} /> */}
                <Grid item className={classes.innercontainer}>
                  {width > 690 && (
                    <Grid
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.patientStatusContainer}
                    >
                      <Typography variant="h4">Patient Status</Typography>
                      <Grid
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.status}
                      >
                        <AutoCompleteTextField
                          open={isOpenStatusList}
                          onOpen={() => {
                            setIsOpenStatusList(true);
                          }}
                          onClose={() => {
                            setIsOpenStatusList(false);
                          }}
                          fullWidth
                          options={statusMenuItems}
                          inputValue={statusValue}
                          getOptionLabel={(option) => option.label}
                          filterOptions={(option) => {
                            let result = [...option];
                            return result || [];
                          }}
                          onChange={(e, value) => handleStatusChange(value)}
                          placeholder="Status"
                          // label="Status *"
                        />
                      </Grid>
                    </Grid>
                  )}
                  <Grid className={classes.rsViewColum}>
                    <Grid item xs={8}>
                      <Typography medium variant="h4">
                        Patients notes: &nbsp;
                        {data?.data?.notes?.length === 0 && <> - </>}
                      </Typography>
                      {data && (
                        <ul className={classes.rsNote}>
                          {data?.data?.notes?.map((item, index) => {
                            return (
                              <li>
                                <Typography
                                  regular
                                  variant="h5"
                                  className={classes.noteStyle}
                                >
                                  {/* <li> */}
                                  {capitalizeFirstLetter(item?.notes || "-")}
                                  {/* </li> */}
                                </Typography>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid marginLeft={"20px"} marginRight={"20px"}>
                <Grid className={classes.rsCollectionTab}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={medicationTable}
                      onChange={handleChangetab}
                      aria-label="basic tabs example"
                    >
                      <Tab
                        label="Medications"
                        value="medication"
                        onClick={() => {
                          setMedicationTable("medication");
                        }}
                      />
                      <Tab
                        label="History"
                        value="medication_history"
                        onClick={() => {
                          setMedicationTable("medication_history");
                        }}
                      />
                    </Tabs>
                  </Box>
                  <Box className={classes.rsEditbutton}>
                    <Button
                      startIcon={
                        <PrimaryIcon
                          icon={Editicons}
                          color="white"
                          width="18px"
                          height="18px"
                        />
                      }
                      className="BtnGreen"
                      variant="contained"
                      onClick={() => {
                        setOpenCreatePatientPopup(true);
                      }}
                    >
                      Edit Patient
                    </Button>
                  </Box>
                  {/* <Button
                    variant={
                      medicationTable === "medication"
                        ? "contained"
                        : "outlined"
                    }
                    color="primary"
                    className={clsx(
                      classes.rsCollectionTabBtn,
                      medicationTable === "medication" && classes.rsActiveButton
                    )}
                    onClick={() => {
                      setMedicationTable("medication");
                    }}
                  >
                    {" "}
                    Medications &nbsp;
                  </Button>
                  <Button
                    variant={
                      medicationTable === "medication_history"
                        ? "contained"
                        : "outlined"
                    }
                    color="primary"
                    className={clsx(
                      classes.rsCollectionTabBtn,
                      medicationTable === "medication_history" &&
                        classes.rsActiveButton
                    )}
                    onClick={() => {
                      setMedicationTable("medication_history");
                    }}
                  >
                    {" "}
                    Medications History &nbsp;
                  </Button> */}
                </Grid>

                {medicationTable === "medication" && (
                  <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>DRUG</TableCell>
                          <TableCell>QTY</TableCell>
                          <TableCell>PRN</TableCell>
                          <TableCell>LAST ORDER ON</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {data?.data?.drugs?.length > 0 && (
                          <>
                            {data?.data?.drugs?.map((item, index) => {
                              return (
                                <TableRow
                                  key={index}
                                  className={classes.tableBody}
                                >
                                  <TableCell className={classes.tableName}>
                                    {item?.name}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableName}
                                    style={{ textAlign: "center" }}
                                  >
                                    {item?.quantity}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableName}
                                    style={{ textAlign: "center" }}
                                  >
                                    {item?.changeable_prn ? (
                                      <TickIconCircle />
                                    ) : (
                                      <CrossIconCircle />
                                    )}
                                    {/* <Chip
                                      label={
                                        item?.changeable_prn ? "Yes" : "No"
                                      }
                                      variant="outlined"
                                      className={clsx(
                                        item?.changeable_prn
                                          ? classes.rsCollectedStatusOne
                                          : classes.rsCollectedStatusTwo
                                      )}
                                    /> */}
                                  </TableCell>

                                  <TableCell
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                    className={classes.tableName}
                                  >
                                    {item?.order_date
                                      ? moment(
                                          new Date(item?.order_date)
                                        ).format("DD-MM-YYYY") || "N / A"
                                      : "-"}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </>
                        )}

                        {data?.data?.drugs?.length == 0 && (
                          <TableRow className={classes.rsTableRow}>
                            <TableCell
                              style={{ borderBottom: `none !important` }}
                              colSpan={5}
                            >
                              <Typography
                                color="secondary"
                                medium
                                variant="h6"
                                textAlign={"center"}
                              >
                                Medication Not found
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}

                {medicationTable === "medication_history" && (
                  <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>DRUG NAME</TableCell>
                          <TableCell>QTY</TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }}>
                            MARKED ARRIVED BY
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }}>
                            ORDER DATE
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }}>
                            ARRIVED AT
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {patientMedicationHistoryList?.data?.list?.length >
                          0 && (
                          <>
                            {patientMedicationHistoryList?.data?.list?.map(
                              (item, index) => {
                                return (
                                  <TableRow className={classes.tableBody}>
                                    <TableCell className={classes.tableName}>
                                      {item?.drug_name}
                                    </TableCell>
                                    <TableCell
                                      className={classes.tableName}
                                      style={{ textAlign: "center" }}
                                    >
                                      {item?.quantity}
                                    </TableCell>
                                    <TableCell className={classes.tableName}>
                                      {capitalizeFirstLetter(
                                        item?.created_by
                                          ? item?.created_by
                                          : "-"
                                      )}
                                    </TableCell>
                                    <TableCell
                                      style={{ whiteSpace: "nowrap" }}
                                      className={classes.tableName}
                                    >
                                      {moment(
                                        new Date(item?.order_date)
                                      ).format("DD-MM-YYYY  ")}
                                      &nbsp;
                                      {moment(
                                        new Date(item?.order_date),
                                        "hh:mm A"
                                      ).format("HH:mm")}
                                    </TableCell>
                                    <TableCell
                                      style={{ whiteSpace: "nowrap" }}
                                      className={classes.tableName}
                                    >
                                      {item?.status !== "collected" ? (
                                        <Box
                                          className={
                                            // item?.status === "archived" &&
                                            // item?.is_archived === 1
                                            //   ? classes.rsDisableArchived
                                            //   : classes.rsArchived
                                            item?.status === null
                                              ? ""
                                              : item?.status === "archived" &&
                                                item?.is_archived === 1
                                              ? classes.rsDisableArchived
                                              : classes.rsArchived
                                          }
                                          onClick={() => {
                                            if (
                                              item?.status === "archived" &&
                                              item?.is_archived === 0
                                            ) {
                                              handleMediArchive(item?.id);
                                            }
                                          }}
                                        >
                                          <HtmlTooltipMain
                                            title={`${moment(
                                              new Date(item?.created_at)
                                            ).format(
                                              "DD-MM-YYYY"
                                            )} ${` `}   ${moment(
                                              new Date(item?.created_at),
                                              "hh:mm A"
                                            ).format("HH:mm")}`}
                                          >
                                            {/* {item?.status === "archived"
                                              ? "Archived"
                                              : "Unarchived"} */}

                                            {item?.status === null
                                              ? "-"
                                              : item?.status === "archived"
                                              ? "Archived"
                                              : "Unarchived"}
                                          </HtmlTooltipMain>
                                        </Box>
                                      ) : (
                                        <>
                                          {item?.created_at !== null ? (
                                            <>
                                              {moment(
                                                new Date(item?.created_at)
                                              ).format("DD-MM-YYYY")}
                                              &nbsp;
                                              {moment(
                                                new Date(item?.created_at)
                                              ).format("HH:mm")}
                                            </>
                                          ) : (
                                            "-"
                                          )}
                                          {/* {moment(
                                            new Date(item?.created_at)
                                          ).format("DD-MM-YYYY")}
                                          &nbsp;
                                          {moment(
                                            new Date(item?.created_at),
                                            "hh:mm A"
                                          ).format("HH:mm")} */}
                                        </>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                            )}
                          </>
                        )}

                        {patientMedicationHistoryList?.data?.list?.length ==
                          0 && (
                          <TableRow className={classes.rsTableRow}>
                            <TableCell
                              style={{ borderBottom: `none !important` }}
                              colSpan={5}
                            >
                              <Typography
                                color="secondary"
                                medium
                                variant="h6"
                                textAlign={"center"}
                              >
                                Medication Not found
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Grid>
            </>
          )}
        </DialogContent>
        {/* <DialogActions>
              <Button
                children="Cancel"
                variant="outlined"
                onClick={() => handleClose()}
              />
            </DialogActions> */}
        {/* </>
         )} */}
      </Dialog>
      <PatientCreateDialog
        open={openCreatePatientPopup}
        setOpen={setOpenCreatePatientPopup}
        // callBackOnSubmit={onSuccessOfSubmitPatientForm}
        createNewPatientFromCSV={data?.data}
        fromPatientDetails
        _patientId={data?.data?.id}
        orderCountPayload={orderCountPayload}
        countUpdateFlag={countUpdateFlag}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  statusUpdate: state.patient.statusUpdate,
});
const mapDispatchToProps = (dispatch) => ({
  getPatientStatusUpdatAction: (id, payload) =>
    dispatch({ type: START_STATUS_PATIENT_UPDATE, id, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientDetailDialog);
